import { render } from "./VoucherRedeem.vue?vue&type=template&id=0b086ebd&scoped=true"
import script from "./VoucherRedeem.vue?vue&type=script&lang=js"
export * from "./VoucherRedeem.vue?vue&type=script&lang=js"

import "./VoucherRedeem.vue?vue&type=style&index=0&id=0b086ebd&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b086ebd"]])

export default __exports__